import { useEffect, useState } from 'react'
import {
	BellIcon,
	BrandsIcon,
	BulbIcon,
	PlayIcon,
	ProjectsIcon,
	SettingsIcon,
	SimpleCrossIcon,
	UpgradeIcon,
} from '../../icons'
import { Modal, ModalPropsI } from '../../util/modal'
import { Logout } from '../logout'
import { BellNotifications } from './bellNotifications'
import { WhatsNew } from './whatsnew'

//react router dom
import { useHistory } from 'react-router-dom'

interface MobileNavbarPropsI {
	isOpen: boolean
	handleClose: () => void
}

export const MobileNvabar: React.FC<MobileNavbarPropsI> = ({
	isOpen,
	handleClose,
}) => {
	//local states
	const [openNotifications, setOpenNotifications] = useState<boolean>(false)
	const [openWhatsNew, setOpenWhatsNew] = useState<boolean>(false)

	//usehistory
	const { push } = useHistory()

	//siable scrolling
	useEffect(() => {
		if (isOpen) document.body.style.overflow = 'hidden'
		return () => {
			if (isOpen) document.body.style.overflow = 'unset'
		}
	}, [isOpen])

	//what'new modal
	const WhatsNewModal: React.FC<ModalPropsI> = ({ onClick, open }) => (
		<section className='whats-new-modal'>
			<Modal open={open} onClick={onClick}>
				<WhatsNew />
			</Modal>
		</section>
	)

	//what'new modal
	const NotificationsModal: React.FC<ModalPropsI> = ({ onClick, open }) => (
		<section className='notifications-modal'>
			<Modal open={open} onClick={onClick}>
				<BellNotifications />
			</Modal>
		</section>
	)

	const onClickHandlerHowDoesItWork = () => {
		handleClose()
		push('/howdoesitwork')
	}

	//if not open return null
	if (!isOpen) return null

	return (
		<>
			<WhatsNewModal
				open={openWhatsNew}
				onClick={() => setOpenWhatsNew(false)}
			/>
			<NotificationsModal
				open={openNotifications}
				onClick={() => setOpenNotifications(false)}
			/>
			<div className='mobile-navbar'>
				<section className='top-level-menu'>
					<section className='button-menus'>
						<section className='top-menu'>
							<section>
								<button onClick={() => setOpenNotifications(true)}>
									<BellIcon /> <p>Notification</p>
								</button>
							</section>
							<section>
								<button onClick={onClickHandlerHowDoesItWork}>
									<PlayIcon /> <p>How does it work?</p>
								</button>
							</section>
							<section>
								<button onClick={() => setOpenWhatsNew(true)}>
									<BulbIcon /> <p>What's new?</p>
								</button>
							</section>
						</section>
						<section className='down-menu'>
							<section>
								<button>
									<BrandsIcon /> <p>Brands</p>
								</button>
							</section>
							<section>
								<button>
									<ProjectsIcon /> <p>Projects</p>
								</button>
							</section>
							<section>
								<button>
									<SettingsIcon /> <p>Settings</p>
								</button>
							</section>
						</section>
					</section>
					<section className='cross-icon'>
						<SimpleCrossIcon onClick={handleClose} />
					</section>
				</section>
				<section className='down-level-menu'>
					<Logout />
					<section className='pack'>
						<section className='upper-side'>
							<section className='texts'>
								<h3>Premium Pack</h3>
								<p>Resets in 3 weeks</p>
							</section>
							<section className='button-section'>
								<button>
									<UpgradeIcon /> Upgrade
								</button>
							</section>
						</section>
						<section className='down-side'>
							<section className='texts'>
								<p>Monthly</p>
								<p>90/100</p>
							</section>
							<section className='progress-bar-container'>
								<div className='progress-bar' />
							</section>
						</section>
					</section>
				</section>
			</div>
		</>
	)
}
